module.exports = __webpack_public_path__ + "static/img/fellowChicken4.7eec000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fellowChicken4.png
// module id = /sSc
// module chunks = 2